import * as webUtils from './web-utils'

/**
 * Node 서버 및 Browser에 global store를 제공
 * ```typescript
 * import { GlobalStore } from '@ustra/core'
 *
 * // 데이터 저장
 * GlobalStore.store('data-key', data)
 *
 * const data:DataType = GlobalStore.get<DataType>('data-key')
 * ```
 * @class
 */
class GlobalStore {
  private getStoreObject(): object {
    return webUtils.isBrowser() ? window : global
  }

  store(key: string, data: any) {
    this.getStoreObject()[key] = data
  }

  get<T = any>(key: string): T {
    return this.getStoreObject()[key] as T
  }

  remove(key: string) {
    delete this.getStoreObject()[key]
  }
}

export default new GlobalStore()
